import orderBy from 'lodash.orderby';
import * as z from 'zod';

const commissionEarningModel = ['Agreement Pricing', 'Wholesale Pricing'] as const;

export const commissionEarningModelQuerySchema = z.enum(commissionEarningModel);

export type CommissionEarningModelQuerySchema = z.infer<typeof commissionEarningModelQuerySchema>;
export type CommissionEarningModelMutationSchema = CommissionEarningModelQuerySchema;

export const commissionEarningModelFormSchema = z.object({
  name: z.string(),
  value: commissionEarningModelQuerySchema,
});

type CommissionEarningModelFormSchema = z.infer<typeof commissionEarningModelFormSchema>;

export const commissionEarningModelOptions = () => {
  return orderBy(
    commissionEarningModel.map((value) => ({
      name: value,
      value,
    })),
    ['name']
  );
};

export function commissionEarningModelToStr(p?: CommissionEarningModelFormSchema) {
  return p?.value ?? 'Agreement Pricing';
}

export function strToCommissionEarningModel(p: CommissionEarningModelQuerySchema): CommissionEarningModelFormSchema {
  return commissionEarningModelOptions().find((option) => option?.value === p) ?? commissionEarningModelOptions()[0];
}

export const defaultCommissionEarningModel = commissionEarningModelOptions()[0];
